export default {
    data () {
        return {
            shipflowStatusList: [
                { id: 1, label: 'เข้ารับวันนี้', status: 'เข้ารับวันนี้' },
                { id: 2, label: 'confirm', status: 'confirm' },
                { id: 3, label: 'เข้ารับสินค้าแล้ว', status: 'รถเข้ารับแล้ว' },
                { id: 4, label: 'ยกเลิกเข้ารับ', status: 'ยกเลิกเข้ารับ' }
            ],
            shipflowPickUpTypeList: [
                { id: 1, label: 'จันทร์-เสาร์' },
                { id: 2, label: 'จันทร์-ศุกร์' },
                { id: 3, label: 'กำหนดเอง' },
                { id: 4, label: 'ครั้งเดียว' }
            ],
            shipFlowCourierList: [
                { id: 1, label: 'SCG', courierId: 1 },
                { id: 2, label: 'FLASH', courierId: 4 },
                { id: 3, label: 'BEE', courierId: 10 },
                { id: 4, label: 'BEST', courierId: 9 }
            ],
            shipflowDayList: [
                { id: 1, label: 'จันทร์', abbreviations: 'จ.' },
                { id: 2, label: 'อังคาร', abbreviations: 'อ.' },
                { id: 3, label: 'พุธ', abbreviations: 'พ.' },
                { id: 4, label: 'พฤหัสบดี', abbreviations: 'พฤ.' },
                { id: 5, label: 'ศุกร์', abbreviations: 'ศ.' },
                { id: 6, label: 'เสาร์', abbreviations: 'ส.' }
            ]
        }
    },
    computed: {
        getShipflowRowSelected () {
            let selectedRow = this.$store.get('booking/shipFlowSelected')
            return selectedRow.length
        }
    },
    methods: {
        getShipflowDayPick (type, dayArr) {
            if (type === 3 && dayArr.length > 0) {
                let dayStr = []
                for (let index in dayArr) {
                    let hasDay = this.shipflowDayList.filter(e => e.id === dayArr[index])
                    if (hasDay.length > 0) {
                        dayStr.push(hasDay[0].label)
                    }
                }
                return dayStr.join()
            } else {
                let hasShipflow = this.shipflowPickUpTypeList.filter((e) => e.id === parseInt(type))
                if (hasShipflow.length > 0) {
                    return hasShipflow[0].label
                } else {
                    return type
                }
            }
        },
        getShipflowTypeName (id) {
            let hasShipflow = this.shipflowPickUpTypeList.filter((e) => e.id === parseInt(id))
            if (hasShipflow.length > 0) {
                return hasShipflow[0].label
            } else {
                return id
            }
        },
        formatShipflowAddress (adressObj) {
            if (adressObj.province === 'กรุงเทพมหานคร') {
                return `${adressObj.address} แขวง${adressObj.subDistrict} เขต${adressObj.district} ${adressObj.province} ${adressObj.zipcode}`
            } else {
                return `${adressObj.address} ต.${adressObj.subDistrict} อ.${adressObj.district} จ.${adressObj.province} ${adressObj.zipcode}`
            }
        },
        formatShipflowPickUpAddress (adressObj) {
            if (adressObj.province === 'กรุงเทพมหานคร') {
                return `${adressObj.address} แขวง${adressObj.sub_district} เขต${adressObj.district} ${adressObj.province} ${adressObj.zipcode}`
            } else {
                return `${adressObj.address} ต.${adressObj.sub_district} อ.${adressObj.district} จ.${adressObj.province} ${adressObj.zipcode}`
            }
        }
    }
}
